export function getDaysUntilExpiration(periodEnd: string | Date): number {
  const endDate = new Date(periodEnd);
  const now = new Date();
  const diffTime = endDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays);
}

export function isSubscriptionExpiringSoon(periodEnd: string | Date, daysThreshold: number = 7): boolean {
  const daysUntilExpiration = getDaysUntilExpiration(periodEnd);
  return daysUntilExpiration <= daysThreshold && daysUntilExpiration > 0;
}

export function getSubscriptionStatusText(
  hasPro: boolean,
  cancelAtPeriodEnd?: boolean,
  periodEnd?: string | Date
): string {
  if (!hasPro) return "Free Plan";
  
  if (cancelAtPeriodEnd && periodEnd) {
    const daysUntil = getDaysUntilExpiration(periodEnd);
    if (daysUntil === 0) return "Pro Plan (Expired)";
    if (daysUntil === 1) return "Pro ends tomorrow";
    return `Pro ends in ${daysUntil} days`;
  }
  
  return "Pro Plan";
}